
(function headerDirectiveDefinition() {
    
    'use strict';

    angular.module('ui.Header')
        .directive('edrHeader', [
            'config',
            function navMenuDirective(config) {
                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/directives/header/header.html'),
                    controller: [
                        '$scope', 'auth', 'navMenu', '$state', 'login', 'messages',
                        function navMenuDirectiveController($scope, auth, navMenu, $state, login, messages) {

                            $scope.rightMargin = 400;

                            auth.onIdentityChanged(function identityChangedFn() {
                                $scope.userName = auth.getUserName();
                                $scope.userNick = auth.getUserNick();
                                navMenu.update();
                            });

                            $scope.userName = auth.getUserName();

                            $scope.logout = function navMenuDirectiveLogOut() {
                                login.logOut()
                                    .then(function() {
                                            $scope.userName = null;
                                        },
                                        function() {
                                            messages.show($scope.logoutErrorText);
                                        });
                            };

                        }
                    ]
                };
            }
        ]);

})();